
import { IComboOperadores, IRequestActualizarEquipo, IRequestDetalleEquipo, IRequestEstadoEquipo } from "../../Interfaces/estadoEquipos/IEstadoEquipo";
import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";

const HistoricoEstadoEquipo = "HistoricoEstadoEquipo"; 
const ListarTotalByEquipo = (request:IRequestDetalleEquipo) => {
    return fetchListVerificacion.post(`${HistoricoEstadoEquipo}/ListarTotalByEquipo`,request);
};
const ListarByEquipo = (request:IRequestEstadoEquipo) => {
    return fetchListVerificacion.post(`${HistoricoEstadoEquipo}/ListarByEquipo`,request);
};
const ComboOperadores = (request:IComboOperadores,controller = new AbortController()) => {
    return fetchListVerificacion.get(`${HistoricoEstadoEquipo}/ComboOperadores` ,{
        params: request,
        signal: controller.signal,
     });
};
const ListarHistoricoEquipo = (request:Ifilter) => {
    return fetchListVerificacion.post(`${HistoricoEstadoEquipo}/Listar`,request);
};
const ActulizarHistoricoEstado = (request:IRequestActualizarEquipo) => {
    return fetchListVerificacion.post(`${HistoricoEstadoEquipo}/ActulizarHistoricoEstado`,request);
};
const InfoHistorico = (HistoricoId:string) => {
    return fetchListVerificacion.get(`${HistoricoEstadoEquipo}/InfoHistorico?HistoricoId=${HistoricoId}`);
};

export const  HistoricoEstadoEquipoService = {
    ListarByEquipo,
    ListarTotalByEquipo,
    ComboOperadores,
    ListarHistoricoEquipo,ActulizarHistoricoEstado,InfoHistorico
}

